// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1dGhb","select":"Header_select__13Ymj","clinic":"Header_clinic__3enWm"};